import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";

export default function PaymentReport() {
  const [filterValues, setFilterValues] = useState({
    month: new Date(),
    paymentStatus: "",
  });
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState({});
  const [lists, setLists] = useState([]);
  const userId = localStorage.getItem("userId");
  const [totalSuccessAmount, setTotalSuccessAmount] = useState(0);
  const [totalPendingAmount, setTotalPendingAmount] = useState(0);

  const headerconfig = {
    headers: { Authorization: "Bearer " + localStorage.getItem("userToken") },
  };

  const handleclear = () => {
    GetData();

    setFilterValues({
      month: new Date(),
      paymentStatus: "",
    });
  };
  const handleSearch = () => {
    GetData();
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterValues({
      ...filterValues,
      [name]: value,
    });
  };
  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    GetData();
  };

  const GetData = (number) => {
    axios
      .get(
        config.APIACTIVATEURL +
          config.GETPAYMENTREPORT +
          "?userId=" +
          userId +
          "&month=" +
          moment(filterValues.month).format("YYYY-MM") +
          "&paymentStatus=" +
          filterValues.paymentStatus,

        { ...headerconfig }
      )
      .then((response) => {
        setLists(response.data.data);
        setData(response.data.data);
        setTotalSuccessAmount(response.data.totalSuccessAmount);
        setTotalPendingAmount(response.data.totalPendingAmount);
      });
  };
  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  useEffect(() => {
    GetData();
  }, []);

  return (
    <div id="layout-wrapper">
      <LayoutHeader />
      <LayoutSideBar />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-0">Payment Report</h4>
                </div>
              </div>
            </div>
            <div className="alert alert-success">
              <form onSubmit={handleSubmit} autoComplete="off">
                <div className="row">
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label>Month</label>
                      <div className="input-group">
                        <Flatpickr
                          value={filterValues.month}
                          className="form-control"
                          options={{
                            dateFormat: "Y-m",
                            plugins: [
                              new (require("flatpickr/dist/plugins/monthSelect"))(
                                {
                                  shorthand: true,
                                  dateFormat: "M-Y",
                                  theme: "light",
                                }
                              ),
                            ],
                          }}
                          onChange={(date) =>
                            setFilterValues({ ...filterValues, month: date[0] })
                          }
                        />
                        <div className="input-group-text bg-primary border-primary text-white">
                          <i className="ri-calendar-2-line" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label htmlFor="paymentStatus" className="form-label">
                        Payment Status
                      </label>
                      <select
                        name="paymentStatus"
                        value={filterValues.paymentStatus}
                        onChange={handleFilterChange}
                        className="form-select"
                      >
                        <option value="">All</option>
                        <option value="SUCCESS">SUCCESS</option>
                        <option value="PENDING">PENDING</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="hstack gap-2 justify-content-middle mb-3 mt-4">
                      <button
                        type="button"
                        className="btn btn-primary w-100"
                        onClick={handleSearch}
                      >
                        Search
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger w-100"
                        onClick={handleclear}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  <div className="card-body">
                    <div className="table-responsive table-card">
                      <table className="table align-middle" id="customerTable">
                        <thead className="table-light">
                          <tr>
                            <th>Client</th>
                            <th>Staff</th>
                            <th>Service</th>
                            <th>Created Date</th>
                            <th>Payment Date</th>
                            <th>Amount</th>
                            <th>Payment Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lists.length > 0 ? (
                            lists.map((v, index) => (
                              <tr key={index}>
                                <td>{v.clientName}</td>
                                <td>{v.staffName}</td>
                                <td>{v.serviceName}</td>
                                <td>
                                  {moment(v.createdDate).format(
                                    "DD-MM-YYYY  hh:mm a"
                                  )}
                                </td>
                                <td>
                                  {moment(v.paymentDate).format(
                                    "DD-MM-YYYY  hh:mm a"
                                  )}
                                </td>

                                <td>{v.amount}</td>
                                <td>
                                  <span
                                    className={
                                      "badge " +
                                      (v.paymentStatus === "SUCCESS"
                                        ? "bg-success"
                                        : "bg-warning")
                                    }
                                  >
                                    {v.paymentStatus}
                                  </span>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" className="text-center">
                                No data available
                              </td>
                            </tr>
                          )}
                        </tbody>
                        {lists.length > 0 && (
                          <tfoot>
                            {filterValues.paymentStatus === "SUCCESS" && (
                              <tr>
                                <td colSpan="5" className="text-end fw-bold">
                                  Total Success Amount:
                                </td>
                                <td colSpan="2" className="fw-bold">
                                  {totalSuccessAmount}
                                </td>
                              </tr>
                            )}
                            {filterValues.paymentStatus === "PENDING" && (
                              <tr>
                                <td colSpan="5" className="text-end fw-bold">
                                  Total Pending Amount:
                                </td>
                                <td colSpan="2" className="fw-bold">
                                  {totalPendingAmount}
                                </td>
                              </tr>
                            )}
                            {filterValues.paymentStatus === "" && (
                              <>
                                <tr>
                                  <td colSpan="5" className="text-end fw-bold">
                                    Total Success Amount:
                                  </td>
                                  <td colSpan="2" className="fw-bold">
                                    {totalSuccessAmount}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="5" className="text-end fw-bold">
                                    Total Pending Amount:
                                  </td>
                                  <td colSpan="2" className="fw-bold">
                                    {totalPendingAmount}
                                  </td>
                                </tr>
                              </>
                            )}
                          </tfoot>
                        )}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
